module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.10095/images/short-black-hair-smiling/short-black-hair-smiling@3x.png"